/*
  Bazaarvoice renders its review count as a bare parenthesised number — "(4871)"
  — with no label, which reads as an orphaned figure beside the stars. The text
  node is BV's own, so it cannot be relabelled in CSS. This rewrites it once the
  widget lands and keeps watching, because BV hydrates late and re-renders the
  container when the variant changes or a card scrolls into view.
*/
(() => {
  const HOST = '.bv-inline-rating';
  const COUNT = '.bv_numReviews_component_container .bv_text';
  const strings = window.themeStrings || {};
  const watched = new WeakSet();

  const label = (count) => {
    const template = count === 1 ? strings.review_count_one : strings.review_count_other;
    if (!template) return `${count.toLocaleString()} ${count === 1 ? 'Review' : 'Reviews'}`;
    return template.replace('[count]', count.toLocaleString());
  };

  const format = (host) => {
    host.querySelectorAll(COUNT).forEach((node) => {
      const digits = (node.textContent || '').replace(/[^0-9]/g, '');
      if (!digits) return;
      const next = label(parseInt(digits, 10));
      if (node.textContent.trim() !== next) node.textContent = next;
    });
  };

  // Watch each widget rather than the document, so an unrelated DOM change —
  // a cart drawer, a slider — does not run this.
  const watch = (host) => {
    if (watched.has(host)) return;
    watched.add(host);
    format(host);
    new MutationObserver(() => format(host)).observe(host, { childList: true, subtree: true });
  };

  const scan = (root) => root.querySelectorAll?.(HOST).forEach(watch);

  scan(document);

  // Cards arrive after load through quick view, infinite scroll and facets.
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(HOST)) watch(node);
        else scan(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
